import { Menu } from 'antd';
import styled from 'styled-components';

const { SubMenu } = Menu;

export const SubMenuCustom = styled(SubMenu)`
  span {
    white-space: normal;
  }

  &.ant-menu-submenu-open {
    border-left: 4px solid #55b249 !important;
    background-color: #fff !important;
    color: #090e38 !important;
    font-weight: bold;

    .ant-menu-submenu-arrow {
      ::before {
        background: #090e38 !important;
      }
      ::after {
        background: #090e38 !important;
      }
    }

    span {
      color: #090e38 !important;
    }

    ul {
      background-color: #fff !important;

      .ant-menu-item {
        margin: 0;
      }

      li {
        margin-top: 0;
        margin-bottom: 0;
        height: 48px !important;

        .ant-row {
          line-height: 48px;
        }

        &:hover {
          background-color: #55b249 !important;
          border-color: #55b249 !important;
          span {
            color: #fff !important;
          }
        }
      }
    }
  }

  .ant-menu-item-selected {
    border-left: 0px;
    background-color: #55b249 !important;
    border-color: #55b249 !important;
    margin-top: 0;
    margin-bottom: 0;
    height: 48px !important;

    .ant-row {
      line-height: 48px;
    }

    span {
      background-color: #55b249 !important;
      color: #fff !important;
    }
  }
`;
